(() => {
  const initialize = (root) => root.querySelectorAll('[data-media-modal]').forEach((modal) => {
    if (modal.dataset.initialized) return;
    modal.dataset.initialized = 'true';
    const section = modal.closest('[data-product-section]');
    const slides = [...modal.querySelectorAll('[data-modal-slide]')];
    const dots = [...modal.querySelectorAll('[data-modal-dot]')];
    let index = 0;
    let opener;
    let previousOverflow;
    const pause = () => {
      modal.querySelectorAll('video').forEach((video) => video.pause());
      modal.querySelectorAll('iframe').forEach((frame) => frame.remove());
      modal.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
    };
    const show = (next) => {
      pause();
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      const template = slides[index].querySelector('template');
      if (template) slides[index].append(template.content.cloneNode(true));
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
      modal.querySelector('[data-modal-status]').textContent = `Media ${index + 1} of ${slides.length}`;
    };
    section.querySelectorAll('[data-media-open]').forEach((tile) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ak-media-open';
      button.setAttribute('aria-label', `Open product media ${Number(tile.dataset.mediaOpen) + 1}`);
      button.setAttribute('aria-haspopup', 'dialog');
      button.addEventListener('click', () => {
        opener = button;
        section.querySelectorAll('[data-media-open] video').forEach((video) => video.pause());
        show(Number(tile.dataset.mediaOpen));
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        modal.showModal();
      });
      tile.append(button);
    });
    modal.querySelector('[data-modal-close]').addEventListener('click', () => modal.close());
    modal.querySelector('[data-modal-prev]')?.addEventListener('click', () => show(index - 1));
    modal.querySelector('[data-modal-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    modal.addEventListener('keydown', (event) => {
      if (event.target.matches('input, textarea, select, video, model-viewer')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    modal.addEventListener('click', (event) => {
      const bounds = modal.getBoundingClientRect();
      if (event.target === modal && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) modal.close();
    });
    const restore = () => {
      pause();
      document.documentElement.style.overflow = previousOverflow || '';
    };
    modal.addEventListener('close', () => { restore(); opener?.focus(); });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(modal) && modal.open) { modal.close(); restore(); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
